<template>
    <div class="wrapper timePickerWrapper">
      <vue-timepicker v-model="theDate" format="HH:mm" :minute-interval="15"></vue-timepicker>
    </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import VueTimepicker from 'vuejs-timepicker'
import { isNil } from 'lodash'
import { bus } from '../main'
export default {
  beforeMount () {
    if (isNil(this.value)) {
      this.value = ''
    }
  },
  components: {
    VueTimepicker
  },
  mixins: [abstractField],
  computed: {
    theDate: {
      get: function () {
        if (this.value !== '' && this.value !== null) {
          var splitTime = this.value.split(':')
          return {HH: splitTime[0], mm: splitTime[1]}
        }
        return {HH: null, mm: null}
      },
      set: function (newValue) {
        this.value = newValue.HH + ':' + newValue.mm
        let hoursToMinutes = (parseFloat(newValue.HH) * 60) + parseFloat(newValue.mm)
        let newAddedTime = hoursToMinutes + 75
        var hours = Math.floor(newAddedTime / 60)
        var minutes = Math.floor((newAddedTime - ((hours * 3600)) / 60))
        let strMinutes = minutes.toString()
        if (strMinutes.length < 2) {
          strMinutes = strMinutes + '0'
        }
        let timeResponse = hours.toString() + ':' + strMinutes
        bus.$emit('addedTimeSep', timeResponse)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldTimePickerSepStartTime.vue